import React from 'react';
import "./aboutMe.scss"
import Exit from '../getBack/exit'
import Aos from 'aos';
import 'aos/dist/aos.css';

function AboutMe() {


    Aos.init()
    return (
        <>               
         <Exit className="exit"/>
            <div className="fullAbout">
                <div className="header">
                        <tr>
                            <td>
                        <div className="aboutWord">
                            ABOUT
                        </div>
                        </td>
                        <td>
                        <div className="meWord">
                            ME
                        </div>
                        </td>
                        </tr>
                </div>
                <div className="subHeader" >
                    <div className="myName">
                        Bohdan Yarish
                    </div>
                    <div className="border"></div>
                    <div className="webDev">
                        WEB DEVELOPER
                    </div>
                </div>
                <div className="about">
                <tr>
                    <div className="text">
                        <div className="textBlock">
                        I started programming 2 years ago using python as my first programming language.
                        After python learning, I decided to learn web development. 
                        I've ended web development Bootcamp where 
                        I got knowledge of many web development concepts. 
                        Now I'm working as a programmer, manager, and speaker at programming courses platform "Speak Learny".
                        </div>
                        <div className="myPhoto"></div>
                    </div>
                </tr>
                </div>
            </div>
        </>
    );
}

export default AboutMe;